(function () {
  'use strict';
  var d = document, root = d.documentElement;
  window.PBS_READY = true;
  root.classList.add('js');
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var design = window.Shopify && window.Shopify.designMode;
  var conn = navigator.connection || {};
  if (conn.saveData || mq('(prefers-reduced-data: reduce)') || (navigator.deviceMemory && navigator.deviceMemory <= 2)) root.classList.add('lite');

  /* Pause water animation when the banner scrolls out of view or the tab is hidden */
  function water(scope) {
    var els = (scope || d).querySelectorAll('[data-water]');
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { x.target.classList.toggle('is-paused', !x.isIntersecting); });
    }, { threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
  }
  d.addEventListener('visibilitychange', function () { root.classList.toggle('tab-hidden', d.hidden); });

  function reveal(scope) {
    var els = (scope || d).querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window) || reduce || design) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        /* A block taller than the screen (like a long item list) can never be 12% in view, so show it as soon as it enters */
        if (x.intersectionRatio >= 0.12 || x.boundingClientRect.height > window.innerHeight * 0.8) { x.target.classList.add('is-visible'); io.unobserve(x.target); }
      });
    }, { threshold: [0, 0.12], rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function header() {
    var h = d.querySelector('[data-header]'); if (!h) return;
    var ticking = false, on = function () { h.classList.toggle('scrolled', window.scrollY > 8); ticking = false; };
    on(); window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(on); } }, { passive: true });
    var btn = h.querySelector('[data-nav-toggle]'), nav = h.querySelector('[data-nav]'); if (!btn || !nav) return;
    var set = function (o) { btn.setAttribute('aria-expanded', o ? 'true' : 'false'); nav.classList.toggle('open', o); };
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  function sliders(scope) {
    (scope || d).querySelectorAll('[data-slider]').forEach(function (s) {
      if (s.__pbs) return; s.__pbs = true;
      var track = s.querySelector('[data-track]'), slides = [].slice.call(s.querySelectorAll('[data-slide]')), dots = [].slice.call(s.querySelectorAll('[data-dot]'));
      if (slides.length < 2) return;
      var i = 0, paused = false, visible = true, interval = parseInt(s.getAttribute('data-interval'), 10) || 7000;
      function mark(n) { dots.forEach(function (dot, k) { dot.setAttribute('aria-current', k === n ? 'true' : 'false'); }); }
      function go(n, instant) { i = (n + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: (reduce || instant) ? 'auto' : 'smooth' }); mark(i); }
      var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { i = Math.round(track.scrollLeft / track.clientWidth); mark(i); }, 100); }, { passive: true });
      var prev = s.querySelector('[data-prev]'), next = s.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      dots.forEach(function (dot) { dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-dot'), 10)); }); });
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { s.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { s.addEventListener(ev, function () { paused = false; }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(s);
      if (!reduce && !design) setInterval(function () { if (!paused && visible && !d.hidden) go(i + 1); }, interval);
      s.__go = go;
    });
  }

  /* Inquiry list. One shared list for the tray, every "Add to inquiry" button and the
     home page inquiry form. Stored as [{n: name}] under pbs_inquiry_v1. No checkout. */
  var KEY = 'pbs_inquiry_v1', OLD = 'pbs-inquiry', mem = [];
  function names(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map(function (it) { return typeof it === 'string' ? it : (it && it.n) || ''; }).filter(Boolean);
  }
  function load() {
    try { var v = localStorage.getItem(KEY); return v === null ? mem.slice() : names(JSON.parse(v)); } catch (e) { return mem.slice(); }
  }
  function store(list) {
    mem = list.slice();
    try { localStorage.setItem(KEY, JSON.stringify(list.map(function (n) { return { n: n }; }))); } catch (e) {}
  }
  function save(list) {
    store(list); render();
    try { d.dispatchEvent(new CustomEvent('pbs:inquiry', { detail: { from: 'theme' } })); } catch (e) {}
  }
  function migrate() {
    try {
      var old = names(JSON.parse(localStorage.getItem(OLD)));
      localStorage.removeItem(OLD);
      if (old.length) {
        var cur = load(); old.forEach(function (n) { if (cur.indexOf(n) < 0) cur.push(n); }); store(cur);
        d.dispatchEvent(new CustomEvent('pbs:inquiry', { detail: { from: 'migrate' } }));
      }
    } catch (e) {}
  }
  function render() {
    var list = load(), tray = d.querySelector('[data-inq]');
    d.querySelectorAll('[data-add]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-add')) > -1 ? 'true' : 'false'); });
    d.querySelectorAll('[data-inquiry-field]').forEach(function (f) { f.value = list.join(', '); });
    if (!tray) return;
    tray.hidden = list.length === 0;
    tray.querySelector('[data-inq-count]').textContent = list.length;
    var ul = tray.querySelector('[data-inq-items]'); ul.innerHTML = '';
    list.forEach(function (name) {
      var li = d.createElement('li'), sp = d.createElement('span'), rm = d.createElement('button');
      sp.textContent = name; rm.type = 'button'; rm.textContent = 'Remove'; rm.setAttribute('aria-label', 'Remove ' + name);
      rm.addEventListener('click', function () { save(load().filter(function (n) { return n !== name; })); });
      li.appendChild(sp); li.appendChild(rm); ul.appendChild(li);
    });
    if (!list.length) panel(false);
  }
  function panel(open) {
    var t = d.querySelector('[data-inq-toggle]'), p = d.querySelector('[data-inq-panel]'); if (!t || !p) return;
    t.setAttribute('aria-expanded', open ? 'true' : 'false'); p.hidden = !open;
  }
  /* Scroll to the inquiry form or contact form, whichever this page has */
  function target(hash) {
    var id = (hash || '').replace('#', '');
    if (id !== 'inquiry' && id !== 'contact') return null;
    return d.getElementById(id) || d.getElementById(id === 'inquiry' ? 'contact' : 'inquiry');
  }
  function home() { var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root; return r || '/'; }
  function goTo(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    try { history.replaceState(null, '', '#' + el.id); } catch (e) {}
  }
  function inquiry() {
    migrate();
    if (/contact_posted=true/.test(location.search)) store([]);
    d.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add]');
      if (add) {
        var name = add.getAttribute('data-add'), list = load(), k = list.indexOf(name);
        if (k > -1) list.splice(k, 1); else list.push(name);
        save(list); return;
      }
      if (e.target.closest('[data-inq-toggle]')) { var p = d.querySelector('[data-inq-panel]'); panel(p.hidden); return; }
      if (e.target.closest('[data-inq-close]')) { panel(false); return; }
      if (e.target.closest('[data-inq-clear]')) { save([]); return; }
      if (e.target.closest('[data-inq-send]')) {
        panel(false);
        var form = d.getElementById('inquiry');
        if (form) { e.preventDefault(); goTo(form); return; }
        return; /* no form on this page: the link opens the home page form */
      }
      var a = e.target.closest('a[href]');
      if (a) {
        var href = a.getAttribute('href'), at = href.indexOf('#');
        var samePage = at === 0 || (at > 0 && href.slice(0, at) === location.pathname);
        if (at > -1 && samePage) {
          var h = href.slice(at), id = h.slice(1);
          if (!d.getElementById(id) && (id === 'inquiry' || id === 'contact')) {
            e.preventDefault();
            var alt = target(h);
            if (alt) goTo(alt); else location.href = home() + '#inquiry'; /* no form on this page: open the home page form */
          }
        }
      }
    });
    d.addEventListener('pbs:inquiry', function (e) { if (!e.detail || e.detail.from !== 'theme') render(); });
    window.addEventListener('storage', function (e) { if (e.key === KEY) { render(); try { d.dispatchEvent(new CustomEvent('pbs:inquiry', { detail: { from: 'storage' } })); } catch (x) {} } });
    if (location.hash && !d.getElementById(location.hash.slice(1))) { var alt = target(location.hash); if (alt) setTimeout(function () { goTo(alt); }, 300); }
    render();
  }

  /* Item list filters and search. Long lists show as pages of 10 that slide sideways (swipe, arrows or keys). */
  function itemLists(scope) {
    (scope || d).querySelectorAll('[data-item-list]').forEach(function (box) {
      if (box.__lists) return; box.__lists = true;
      var PER = 10, cat = '', q = '', rows = [].slice.call(box.querySelectorAll('[data-item]')), empty = box.querySelector('[data-empty]');
      var ul = box.querySelector('.il-rows'), paged = !!ul && rows.length > PER, track, pages = [], cur = 0, total = 0, navs = [], timer;
      function nav(where) {
        var n = d.createElement('div'); n.className = 'il-nav il-nav-' + where;
        n.innerHTML = '<button type="button" class="il-step" data-step="-1" aria-label="Previous 10 items"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg><span>Previous</span></button>' +
          '<span class="il-count" aria-live="polite"></span>' +
          '<button type="button" class="il-step" data-step="1" aria-label="Next 10 items"><span>Next</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>';
        n.addEventListener('click', function (e) {
          var b = e.target.closest('[data-step]'); if (!b || b.disabled) return;
          go(cur + parseInt(b.getAttribute('data-step'), 10), true);
          if (where === 'bottom' && navs[0].getBoundingClientRect().top < 0) navs[0].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
        navs.push(n); return n;
      }
      function fit() { if (paged) track.style.height = pages[cur] ? pages[cur].offsetHeight + 'px' : '0px'; }
      function sync() {
        var n = pages.length, from = cur * PER + 1, to = Math.min(total, from + PER - 1);
        navs.forEach(function (v) {
          v.hidden = n < 2;
          v.querySelector('.il-count').innerHTML = '<strong>' + from + '&ndash;' + to + '</strong> of ' + total + ' <span class="il-page-of">&middot; page ' + (cur + 1) + ' of ' + n + '</span>';
          v.querySelector('[data-step="-1"]').disabled = cur === 0;
          v.querySelector('[data-step="1"]').disabled = cur >= n - 1;
        });
        pages.forEach(function (p, i) { if (i === cur) p.removeAttribute('inert'); else p.setAttribute('inert', ''); p.setAttribute('aria-hidden', i === cur ? 'false' : 'true'); });
        fit();
      }
      function go(i, smooth) {
        cur = Math.max(0, Math.min(pages.length - 1, i));
        track.scrollTo({ left: cur * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
        sync();
      }
      function build(list) {
        track.innerHTML = ''; pages = []; total = list.length;
        for (var i = 0; i < list.length; i += PER) {
          var p = d.createElement('ul'); p.className = 'il-rows il-page';
          list.slice(i, i + PER).forEach(function (r) { r.hidden = false; p.appendChild(r); });
          track.appendChild(p); pages.push(p);
        }
        cur = 0; track.scrollLeft = 0; sync();
      }
      if (paged) {
        track = d.createElement('div'); track.className = 'il-track'; track.tabIndex = 0;
        track.setAttribute('role', 'region'); track.setAttribute('aria-label', 'Items, 10 per page. Swipe or use the arrows for more.');
        ul.parentNode.insertBefore(nav('top'), ul);
        ul.parentNode.insertBefore(track, ul);
        ul.parentNode.insertBefore(nav('bottom'), ul);
        ul.remove();
        track.addEventListener('scroll', function () {
          clearTimeout(timer);
          timer = setTimeout(function () { var i = Math.round(track.scrollLeft / (track.clientWidth || 1)); if (i !== cur && pages[i]) { cur = i; sync(); } }, 90);
        }, { passive: true });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, true); }
        });
        window.addEventListener('resize', function () { track.scrollLeft = cur * track.clientWidth; fit(); });
        window.addEventListener('load', fit);
        build(rows);
      }
      function apply() {
        var ok = rows.filter(function (r) {
          return (!cat || r.getAttribute('data-cat') === cat) && (!q || r.getAttribute('data-name').toLowerCase().indexOf(q) > -1 || r.getAttribute('data-cat').toLowerCase().indexOf(q) > -1 || (r.getAttribute('data-meta') || '').toLowerCase().indexOf(q) > -1);
        });
        if (paged) build(ok); else rows.forEach(function (r) { r.hidden = ok.indexOf(r) < 0; });
        if (empty) empty.hidden = ok.length > 0;
      }
      box.querySelectorAll('[data-filter]').forEach(function (b) {
        b.addEventListener('click', function () {
          box.querySelectorAll('[data-filter]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          cat = b.getAttribute('data-filter'); apply();
        });
      });
      var s = box.querySelector('[data-search]');
      if (s) s.addEventListener('input', function () { q = s.value.trim().toLowerCase(); apply(); });
    });
  }

  /* Product gallery thumbnails */
  function gallery(scope) {
    (scope || d).querySelectorAll('[data-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-gallery-main] img');
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          main.removeAttribute('srcset'); main.src = t.getAttribute('data-src');
          g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
        });
      });
    });
  }
  /* "Ask about this item" fills the message box */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ask]'); if (!a) return;
    var msg = d.querySelector('[data-inquiry-message]');
    if (msg && msg.value.indexOf(a.getAttribute('data-ask')) === -1) msg.value = 'I\'d like to ask about ' + a.getAttribute('data-ask') + '.\n\n' + msg.value;
    if (msg) setTimeout(function () { msg.focus({ preventScroll: true }); }, 600);
  });

  function init(scope) { reveal(scope); sliders(scope); water(scope); itemLists(scope); gallery(scope); }
  header(); init(); inquiry();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); render(); });
  d.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest('[data-slider]'); if (s && s.__go) s.__go(parseInt(e.target.getAttribute('data-index'), 10) || 0, true);
  });
})();
